import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="departure-form"
export default class extends Controller {
  static targets = ["otherReason", "otherReasonField", "selectReason"]

  static classes = ["hidden"]

  checkOtherSelected() {
    const selectedOption = this.selectReasonTarget.options[this.selectReasonTarget.selectedIndex];

    if (selectedOption.text === "Other") {
      this.otherReasonTarget.classList.remove(this.hiddenClass);
      this.otherReasonFieldTarget.focus();
    } else {
      this.otherReasonTarget.classList.add(this.hiddenClass);
    }
  }
}
